/**
 * Route for `dpf`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DpfPage } from "../features/dpf/DpfPage";

export const dpfRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/dpf",
	component: DpfPage,
});

export default dpfRoute;
